<template>
    <div class="wrapper">
        <TitleModules title="公司简介" english="INTRODUCE" type="blue"></TitleModules>
        <div class="content">
            <div class="text-section">上海勤联物联网有限公司简称勤联科技，英文名Shanghai Qlian I.O.T Co.Ltd ，注册地徐汇区，注册资本1176万元，是上海市高新技术企业拥有ICP、人力资源许可证、互联网食品销售许可证等证书，累计服务超过1000万会员！业务涵盖APP、微信端和支付宝端。</div><br>
            <!-- <div class="text-section">截止目前拥有37个软件著作权、15个商标，2020年通过企业知识产权管理体系认证（GB/T29490-2013）,是一家专注研发创新和注重知识产权的公司！同时主动协助客户获得了数十个软件著作权！</div> -->
            <!-- <img class="partners-img" data-src="../../static/img/aptitude-img.png" alt=""> -->
        </div>
        <div class="founders-box">
            <TitleModules title="勤联科技创始人" english="FOUNDER" type="blue"></TitleModules>
          <div class="teamText">{{teamText}}</div>
          <div class="teamBox">
            <!-- <img class="team" :data-src="team" alt=""> -->
          </div>
<!--            <div class="founders-img">-->
<!--                <div class="founder-item" v-for="(item,index) in founders" :key="index">-->
<!--                    <img :data-src="item.img" alt="">-->
<!--                    <div class="founder-info">{{item.text}}</div>-->
<!--                </div>-->
<!--            </div>-->
        </div>

        <TitleModules title="支付宝讲师" english="ALIPAY LECTURER" type="blue"></TitleModules>
        <div class="img-text-content-box">
            <div class="text-content-box" style="margin-right: 70px;">
                <div class="text-content-title">在线直播演讲教商家数字化</div>
                <div class="text-content-subtitle">TEACH BUSINESS DIGITALIZATION</div>
                <div class="text-content">在支付宝大学教授小程序运营开发理念，为更多的公司带来与众不同的运营、开发、产品设计思路。</div>
            </div>
            <div class="img-content-box">
                <img class="content-img9" data-src="../../static/img/content-img9.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import TitleModules from '../components/Title-modules'
export default {
    name: 'user',
    components: {
        TitleModules
    },
    data(){
        return {
          team: require('../../static/team.png'),
          teamText: '公司创始团队毕业于清华大学、中欧国际工商学院等名校，拥有成功连续创业经验，愿景是将运动健康和社交电商结合希望看到更多的客户生活更健康美好！',
            founders: [
                // {
                //     img: require('../../static/img/founder1.png'),
                //     text: '周俊，本科毕业于郑州大学金融数学专业，2017年毕业于浙江大学金融学硕士，毕业后一直在VC创投任职，担任杭州万豪投资管理有限公司投资总监，成功投资IT互联网、新零售领域等多家企业并退出，目前担任上海勤联物联网有限公司董事长'
                // },
                // {
                //     img: require('../../static/img/founder2.png'),
                //     text: '朱慧觉，中国民主建国会会员，2017年毕业于中欧国际工商学院工商管理硕士，清华大学经济管理学院研究生在读，连续创业者，2005年进入互联网行业从事技术研发、管理和产品运营工作，目前担任上海勤联物联网有限公司总经理 '
                // },
                // {
                //     img: require('../../static/img/founder3.png'),
                //     text: '高玮琨，中国民主建国会，毕业于华东师范大学计算机本科，是互联网连续创业者，沉浸互联网行业15年，参与过多个千万级用户量级的移动APP项目研发和运营！目前担任上海勤联物联网有限公司总裁'
                // }
            ]
        }
    },
    created(){
        localStorage.setItem('path','./user')
        localStorage.setItem('index',4)
    },
    mounted(){
        this.handleScroll()
    },
    methods: {
        handleScroll(){
            const images = document.querySelectorAll("img");
            // 传给IntersectionObserver的回调函数
            // 在目标元素能看见时触发一次，目标元素看不见了时再触发一次
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const image = entry.target;
                        const data_src = image.getAttribute("data-src");
                        image.setAttribute("src", data_src);
                        console.log('触发')
                        // 图片被加载后取消观察
                        observer.unobserve(image);
                    }
                });
            });
            images.forEach(image => {
                observer.observe(image);
            });
        }
    }
}
</script>
<style scoped>
@media only screen and (max-width: 1480px){
    .content-img9{
        height: 511px;
    }
.content{
        width: 1052px;
        margin: 0 auto;
    }
    .text-section{
        text-indent:2em;
        font-size: 21px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #2B2E48;
        line-height: 40px;
    }
    .partners-img{
        width: 100%;
        margin-top: 54px;
    }
    .founders-img{
        width: 1052px;
        margin: 100px auto;
        display: flex;
        justify-content: space-between;

    }
    .founder-item{
        width: 340px;
        position: relative;
    }
    .founder-item > img{
        width: 340px;
    }
    .founder-info{
        width: 340px;
        position: absolute;
        box-sizing: border-box;
        padding: 0 17px;
        left: 0;
        bottom: 13px;
        font-size: 17px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 30px;
    }

    .img-text-content-box{
        width: 100%;
        height: 600px;
        display: flex;
        justify-content: center;
        align-items:center;
    }
    .text-content-box{
        width: 580px;
        position: relative;
    }
    .text-content-title{
        font-size: 37px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 51px;
    }
    .text-content-subtitle{
        font-size: 25px;
    }
    .text-content{
        width: 553px;
        font-size: 21px;
        line-height: 40px;
        margin-top: 40px;
    }
    .text-content > span{
        font-size: 24px;
        font-weight: bold;
        color: #4468E6;
    }
    .number-bg{
        position: absolute;
        height: 285px;
        left: 40px;
        top: -65px;
    }
  .teamText{
    width: 72%;
    margin: 0 auto;
    text-align: center;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 55px;
  }
  .teamBox{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .team{
    width:85%;
    margin-top: 50px;
  }
}
@media only screen and (min-width: 1480px){
    .content-img9{
        height: 720px;
    }
.content{
    width: 1480px;
    margin: 0 auto;
}
.text-section{
    text-indent:2em;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #2B2E48;
    line-height: 56px;
}
.partners-img{
    width: 100%;
    margin-top: 120px;
}
.founders-box{
    background: #F6F7FC;
    overflow: hidden;
    margin-top: 100px;
    padding-bottom: 120px;
}
.founders-img{
    width: 1540px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.founder-item{
    width: 480px;
    position: relative;
}
.founder-item > img{
    width: 480px;
}
.founder-info{
    width: 480px;
    position: absolute;
    box-sizing: border-box;
    padding: 0 25px;
    left: 0;
    bottom: 20px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 43px;
}

.img-text-content-box{
    width: 100%;
    height: 830px;
    display: flex;
    justify-content: center;
    align-items:center;
}
.text-content-box{
    width: 810px;
    position: relative;
}
.text-content-title{
    font-size: 52px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 72px;
}
.text-content-subtitle{
    font-size: 34px;
}
.text-content{
    width: 778px;
    font-size: 30px;
    line-height: 56px;
    margin-top: 50px;
}
.text-content > span{
    font-size: 34px;
    font-weight: bold;
    color: #4468E6;
}
.number-bg{
    position: absolute;
    height: 285px;
    left: 40px;
    top: -65px;
}
  .teamText{
    width: 72%;
    margin: 0 auto;
    text-align: center;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 55px;
  }
  .teamBox{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .team{
    width:85%;
    margin-top: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user.vue